import { render } from "./SearchSummaryTotalElementsLabel.vue?vue&type=template&id=195b01d4&scoped=true"
import script from "./SearchSummaryTotalElementsLabel.vue?vue&type=script&lang=js"
export * from "./SearchSummaryTotalElementsLabel.vue?vue&type=script&lang=js"

import "./SearchSummaryTotalElementsLabel.vue?vue&type=style&index=0&id=195b01d4&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-195b01d4"]])

export default __exports__